import React from 'react';
import { toDateFormat, monthName } from 'utils/date';
import Avatar from 'shared/components/avatar/Avatar';
import { connect } from 'react-redux';

const ClientSide = props => {
  let { client, trainer } = props;
  let firstLetters =
    client.first_name && client.last_name
      ? `${client.first_name[0].toUpperCase()}${client.last_name[0].toUpperCase()}`
      : '';
  let clientCreatedAt = '-';
  if (client.created_at) {
    let dateFormat = toDateFormat(client.created_at);
    clientCreatedAt = `${monthName(
      dateFormat
    )} ${dateFormat?.getDate()}, ${dateFormat?.getFullYear()}`;
  }

  return (
    <div className="client-profile-side">
      <Avatar
        src={client.photo || ''}
        width="120"
        height="120"
        name={`${client.first_name} ${client.last_name}`}
        firstLetters={firstLetters}
        url={`/clients/${client.id}`}
      />
      <div className="info-section">
        <label>Goal</label>
        <p>{client.client_goal ? `"${client.client_goal}"` : '-'}</p>
      </div>
      <div className="info-section">
        <label>Active Since</label>
        <p>{clientCreatedAt}</p>
      </div>
      <div className="info-section">
        <label>Trainer</label>
        <p>{`${trainer?.first_name} ${trainer?.last_name}` || '-'}</p>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer
  };
}

export default connect(mapStateToProps, null)(ClientSide);
